import React from "react";
import { toast } from "react-toastify";
import {
  Card,
  CardBody,
  CardImg,
  CardText,
  Col,
  Container,
  Row,
} from "reactstrap";

const Cards = ({ pass }) => {
  //    const {photos} = pass

  // console.log(pass);
  const name = pass.author;
  const Name = name.toUpperCase();
  //  const photo = photos.photos

  //  console.log(photo.photos)

  // if(pass = []){
  //   toast("No Internet or Serve is down ,please try again",{type:"error"})
  // }
  return (
    <Container>
      <Card className="mt-2 mb-6">
        <CardImg height="280px" width="80%" src={pass.potraitImage}></CardImg>
        <CardBody className="text-center mb-2 bg-secondary ">
        By{" "}
        <a href={pass.author_url} className="text-white" target="_blank">
          {Name}
        </a>
      </CardBody>
      </Card>
    </Container>
  );
};

export default Cards;
